import React, { Component } from "react";
import PageLink from "../../../components/Page/PageLink";
import Footer from "../../../components/Footer/Footer";
import colors from "../../../colors";

class Material_colors extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const COLORS = colors.map((c, index) => (
      <span
        key={index}
        style={{
          padding: 5,
          width: 189,
          display: "inline-block",
          verticalAlign: "top"
        }}
      >
        <div style={{ fontWeight: "bold" }}>{c.name}</div>
        {c.colors.map((col, index) => (
          <div
            key={index}
            style={{
              padding: 5,
              backgroundColor: col.color,
              borderTop:
                index === 0 ? "solid 1px rgba(0, 0, 0, 0.12)" : undefined,
              borderBottom: "solid 1px rgba(0, 0, 0, 0.12)",
              borderLeft: "solid 1px rgba(0, 0, 0, 0.12)",
              borderRight: "solid 1px rgba(0, 0, 0, 0.12)"
            }}
          >
            {col.dark === true ? (
              <span style={{ color: "#ffffff", fontWeight: 500 }}>
                {col.name}
              </span>
            ) : (
              <span style={{ fontWeight: 500 }}>{col.name} </span>
            )}
            {col.dark === true ? (
              <span
                style={{ color: "#ffffff", fontWeight: 500, float: "right" }}
              >
                {col.color}
              </span>
            ) : (
              <span style={{ fontWeight: 500, float: "right" }}>
                {col.color}{" "}
              </span>
            )}
          </div>
        ))}
      </span>
    ));

    return (
      <div className="row" id="material_colors">
        <div className="col-md-6">
          <div className="contentLight">
            <section>
              <h2>Material Design Colours</h2>
              <p>
                At Nexoid we use the color pallets outlined in the Material
                Design guidelines created by Google. It has been our experience
                that colors are important. Some users navigate by words and
                others pictures and colors. With the goal of trying to make your
                interface design as usable as possible we encourage you to use
                bright colours and icons.{" "}
              </p>
              <div>{COLORS}</div>
              <Footer
                section={this.props.section}
                article={this.props.article}
                routeParams={this.props.routeParams}
              />
            </section>
          </div>
        </div>
        <div className="hidden-sm-xs col-md-6 darkCol ">
          <div className="contentDark"></div>
        </div>
      </div>
    );
  }
}

export default Material_colors;



// WEBPACK FOOTER //
// ./src/components/knowlege/interface/Material_colors.js